export const DIRECTION = {
    LEFT: 'left',
    RIGHT: 'right',
};
